import React from 'react';

interface MarkdownRendererProps {
  content: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
  const renderMarkdown = (text: string): React.ReactNode => {
    if (!text) return null;

    // Split by lines to process each line
    const lines = text.split('\n');
    
    return lines.map((line, index) => {
      const trimmedLine = line.trim();
      
      // Skip empty lines
      if (!trimmedLine) {
        return <br key={index} />;
      }

      // Handle bold text (**text**)
      if (trimmedLine.includes('**')) {
        const parts = trimmedLine.split(/(\*\*.*?\*\*)/g);
        return (
          <span key={index}>
            {parts.map((part, partIndex) => {
              if (part.startsWith('**') && part.endsWith('**')) {
                return <strong key={partIndex}>{part.slice(2, -2)}</strong>;
              }
              return part;
            })}
            {index < lines.length - 1 && <br />}
          </span>
        );
      }

      // Handle numbered lists (1. 2. 3. etc.)
      if (/^\d+\.\s/.test(trimmedLine)) {
        return (
          <div key={index} className="flex">
            <span className="mr-2">{trimmedLine.match(/^\d+\.\s/)?.[0]}</span>
            <span>{trimmedLine.replace(/^\d+\.\s/, '')}</span>
            {index < lines.length - 1 && <br />}
          </div>
        );
      }

      // Handle bullet points (- • *)
      if (/^[-•*]\s/.test(trimmedLine)) {
        return (
          <div key={index} className="flex">
            <span className="mr-2">•</span>
            <span>{trimmedLine.replace(/^[-•*]\s/, '')}</span>
            {index < lines.length - 1 && <br />}
          </div>
        );
      }

      // Regular text
      return (
        <span key={index}>
          {trimmedLine}
          {index < lines.length - 1 && <br />}
        </span>
      );
    });
  };

  return (
    <div className="markdown-content">
      {renderMarkdown(content)}
    </div>
  );
};

export default MarkdownRenderer; 